import { ResolveFn } from '@angular/router';
import { ApiManufacturer, ApiProduct, ApiV1Service } from 'api';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';

export type ProductWithAncestors = ApiProduct & {
  manufacturer: ApiManufacturer;
};

export const ProductResolver: ResolveFn<ProductWithAncestors> = (
  route,
): Observable<ProductWithAncestors> => {
  return inject(ApiV1Service)
    .getProduct(route.params['productId'])
    .pipe(
      map((product) => ({
        ...product,
        manufacturer: route.data['Manufacturer'],
      })),
    );
};
